import React from 'react';

import { useProfileQuery } from 'hooks/queries';
import { SinglePage } from 'components/layout';

import View from './View';

const ProfilePage = () => {
  const profileQuery = useProfileQuery();

  return (
    <SinglePage
      query={profileQuery}
      render={(profile) => <View profile={profile} />}
    />
  );
};

export default ProfilePage;
